/**
 * WPrezentation — polskie tłumaczenia (slider hero).
 *
 * Stringi UI chrome (nav buttons, fallback alts, CTA). Tytuły/podtytuły
 * slajdów pochodzą z backendu per locale (admin edytuje slajd osobno
 * dla każdego języka).
 */
import type { DeepString } from "@/lib/i18n";

export const pl = {
  empty: "Brak slajdów do wyświetlenia.",
  prevSlide: "Poprzedni slajd",
  nextSlide: "Następny slajd",
  cta: "Zobacz więcej",
  openSlideAria: "Otwórz",
  youtubeTitleFallback: "Film YouTube",
} as const;

export type WPrezentationTranslations = DeepString<typeof pl>;
